"use strict";

var HeaderMotif = /* @__PURE__ */(HeaderMotif2 => {
  HeaderMotif2["DarkText"] = "DarkText";
  HeaderMotif2["LightText"] = "LightText";
  return HeaderMotif2;
})(HeaderMotif || {});
const DROPDOWN_KEY = "dropdown";
const LIGHT_KEY = "light";
export { DROPDOWN_KEY, HeaderMotif, LIGHT_KEY };
//# sourceMappingURL=HeaderContent.types.mjs.map
